var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCommunicationWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M4.625 7.431a.78.78 0 0 1 .788.773v5.473a.78.78 0 0 1-.788.773s-.081.021.075 0c-2.005 0-3.7-1.593-3.7-3.56 0-1.966 1.695-3.459 3.7-3.459h-.075zM21.38 2.093S23 1.422 23 3.681v14.558c0 2.258-1.62 1.588-1.62 1.588-2.394-1.626-4.335-2.703-6.073-3.42v5.028a.571.571 0 0 1-.577.565h-2.703a.57.57 0 0 1-.576-.565v-6.2c-1.84-.33-2.85-.205-3.607-.237h-.445a.877.877 0 0 1-.886-.868V7.79c0-.48.396-.869.886-.869h.445c2.158-.04 5.462.655 13.536-4.828z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCommunicationWhite);
export default __webpack_public_path__ + "static/media/ic-communication-white.f0b4c88cb06574bba1f8334d2372f6a2.svg";
export { ForwardRef as ReactComponent };